module.exports = __webpack_public_path__ + "img/product_70.6d9ba7f.webp";